// =============================================================================
// SPINNER COMPONENT - Consistent loading indicator (Bogwood primary)
// =============================================================================

import { Loader2 } from 'lucide-react';

export type SpinnerSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

const sizeClasses: Record<SpinnerSize, string> = {
  xs: 'w-3 h-3',
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-8 h-8',
  xl: 'w-12 h-12',
};

interface SpinnerProps {
  size?: SpinnerSize;
  className?: string;
  /** Tailwind text colour class. Defaults to text-primary. */
  color?: string;
}

export function Spinner({ size = 'md', className = '', color = 'text-primary' }: SpinnerProps) {
  return (
    <Loader2
      className={`animate-spin ${sizeClasses[size]} ${color} ${className}`}
      aria-label="Loading"
    />
  );
}

// Full-page centered spinner
export function PageSpinner({ size = 'lg' }: { size?: SpinnerSize }) {
  return (
    <div className="flex items-center justify-center h-full min-h-[200px]">
      <Spinner size={size} />
    </div>
  );
}

// Inline spinner for buttons - inherits current text colour
export function ButtonSpinner() {
  return <Spinner size="sm" color="text-current" />;
}
